export const procedimientoDetalleModel = {
  id: null,
  co: null,
  np: null,
  st: false,
};
